module.exports = __webpack_public_path__ + "img/yc.3307a21f.jpg";